import { ThemeSpaceVariable, ToggleButton } from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { isOtherRuleTimeOverlapping } from "components/selection-components/select-activity/use-times-to-nudge";
import { useAllTimeSets } from "hooks/use-all-time-sets";
import { useMemo } from "react";
import { Time } from "store/store-types";
import { TimeSlot } from "types/time-slot";
import PulseAnimation from "./pulse-animation";
interface IActivityTimeSlot {
    time: TimeSlot;
    selectedTime: TimeSlot | undefined;
    onClick?: () => void;
    timesToNudge: Time[];
    trackingId?: string;
    ignoredRuleIds?: Set<number>;
}

export default function ActivityTimeSlot({
    time,
    selectedTime,
    onClick,
    timesToNudge = [],
    trackingId,
    ignoredRuleIds,
}: IActivityTimeSlot) {
    const allTimeSets = useAllTimeSets();
    const selectedTimes = useWebBooking().data?.getBookTimes();

    const isSelected =
        time.ruleId === selectedTime?.ruleId && time.start.isSame(selectedTime?.start);

    const currentTimeSet = useMemo(
        () => allTimeSets?.find((rule) => rule.id === time.ruleId),
        [allTimeSets, time.ruleId]
    );

    const disable = isOtherRuleTimeOverlapping(
        time,
        selectedTimes ?? [],
        allTimeSets ?? [],
        currentTimeSet!,
        ignoredRuleIds
    );

    const shouldNudgeTime = timesToNudge.some((nudgeTime) => nudgeTime.start.isSame(time.start));
    return (
        <PulseAnimation isActive={shouldNudgeTime && !isSelected} forceBorder>
            <ToggleButton
                key={time.start.format("HH:mm")}
                onClick={onClick}
                isPressed={isSelected}
                w="full"
                px={ThemeSpaceVariable.Small}
                size="lg"
                isDisabled={disable}
                data-track-click={trackingId}
            >
                {time.start.format("HH:mm")}
            </ToggleButton>
        </PulseAnimation>
    );
}
